const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const localizationHeaders = {
  'X-Timezone': userTimezone
};